// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__tuIl4","container":"footer_container__iHqUl","section__footer":"footer_section__footer___1Hl9","title__section":"footer_title__section__ABpuS"};